import React, { Component } from 'react'
import SimpleFormat from 'client/shared/blocks/simple-format'

import './comment-reply.styl'

type Props = {
  uuid: string
  content: string
  kind: 'default' | 'in-form'
}

export class CommentReply extends Component<Props> {
  static defaultProps = {
    kind: 'default',
  }

  state = {
    expanded: false,
  }

  toggle = () => {
    this.setState({
      expanded: !this.state.expanded,
    })
  }

  render(): JSX.Element {
    const { expanded } = this.state
    const { kind, content } = this.props
    const kindMod = `comment-reply_${kind}`

    return (
      <div
        className={`comment-reply ${
          expanded ? 'comment-reply_expanded' : ''
        } ${kindMod}`}
        onClick={this.toggle}
      >
        <SimpleFormat text={content} classModifiers={['comment-reply']} />
      </div>
    )
  }
}
